// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"input_wrapper__1U5xI","label":"input_label__na2Zl","input":"input_input__1IAcy"};